module.exports = __webpack_public_path__ + "static/media/unify-signout.cc279f78.svg";